module.exports = __webpack_public_path__ + "static/img/view3-1.fbe8714.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lobby/components1030/img/1030/view3-1.png
// module id = kFGw
// module chunks = 1